import React, {PureComponent} from 'react';
import Thirdparty from "./thirdparty/Thirdparty";
import LoginForm from "./form/LoginForm";
import RegForm from "./form/RegForm";
import Header from "./header/Header";
import './login.scss'
import pubsub from 'common/js/pubsub';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Tips from "./tips/Tips";
import $ from 'jquery'

export default class Login extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			isLoginTab: true,
			isShowForm: true,
			tipsMsg: '登录成功',
			tipsType: 'login',
			phone: '',
			password: ''
		};

		this.closeSelfTimer = null;

		this.closeSelf = this.closeSelf.bind(this);
		this.changeTab = this.changeTab.bind(this);
		this.stopPropagation = this.stopPropagation.bind(this);

		this.init();
	}

	componentDidMount() {
		this._mounted = true;
		this.execPosition();
	}

	componentWillUnmount() {
		this._mounted = false;
	}


	init() {
		let self = this;

		pubsub.subscribe('showLoginTab', function() {
			self.changeTab('login');
		});

		pubsub.subscribe('showRegTab', function() {
			self.changeTab('reg');
		})

		pubsub.subscribe('showSuccessTips', function(msg, args) {
			self._mounted && self.setState({
				isShowForm: false,
				tipsMsg: args.msg,
				tipsType: args.type || 'login',
				phone: args.phone,
				password: args.password
			});

			if(args.type !== 'reg'){
				clearTimeout(self.closeSelfTimer);
				self.closeSelfTimer = setTimeout(function(){
					self._mounted && pubsub.publish('hideLogin');
				}, 1000);
			}

		});
	}

	changeTab(type) {
		if(type === 'reg') {
			this._mounted && this.setState({
				isShowForm: true,
				isLoginTab: false
			});
		}else {
			this._mounted && this.setState({
				isShowForm: true,
				isLoginTab: true
			});
		}
		setTimeout(()=>this.execPosition(), 0);
	}

	closeSelf() {
		pubsub.publish('hideLogin');
	}

	stopPropagation(e) {
		e.stopPropagation();
	}

	execPosition() {
		let $login = $("#J-login-con"),
			height = $(window).height(),
			objHeight = $login.height();
		$login.css("top", (height - objHeight) / 2)
	}

	render() {
		return (
			<ReactCSSTransitionGroup
				transitionName="shade"
				transitionAppear={true}
				transitionLeaveTimeout={500}
				transitionAppearTimeout={500}
				transitionEnterTimeout={500}>
			<div className="m-login"
			     onClick={this.closeSelf}>
				<ReactCSSTransitionGroup
					transitionName="offset"
					transitionAppear={true}
					transitionLeaveTimeout={500}
					transitionAppearTimeout={500}
					transitionEnterTimeout={500}>
				<div id="J-login-con" className="m-login_con"
				     onClick={this.stopPropagation}>
					<Header title={this.state.isLoginTab ? '登录' : '注册'}/>
					{ this.state.isShowForm ?
						<div>
							{this.state.isLoginTab ? <LoginForm /> : <RegForm />}
							<Thirdparty />
						</div> : <Tips msg={this.state.tipsMsg}
									   type={this.state.tipsType}
										phone={this.state.phone}
										password={this.state.password}/>
					}
				</div>
				</ReactCSSTransitionGroup>
			</div>

			</ReactCSSTransitionGroup>
		)
	}
}


// WEBPACK FOOTER //
// ./src/views/login/Login.jsx